import mapActions from './mapActions';

export default mapActions('category_material_items', {
    fetchAll_url: (data) => `/api/material_items/category/${data.id}`,
});
